import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormContext from "../context/formContext";
import Loader from "./loader";
import { Toast, useToast } from "@chakra-ui/react";


function Login() {
  const [userLogin, setUserLogin] = useState({});
  const navigate = useNavigate();
  const toast = useToast("")
  const [loginloader, setLoginloader] = useState(false);
  const context = useContext(FormContext);
  const {setLoginObj, setPreviewlink } = context;


  const handleLoginSubmit = (e) => {
    e.preventDefault();
    
    setLoginloader(true);
    // userLogin["Branch_id"] = "1790";
    userLogin["Branch_id"] = "2245";
    userLogin['db_name'] = "erp_eshiksa";
    userLogin["student_id"] = localStorage.getItem('studentId');
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ci_session=impg6f888nji7ij8jfr10rrebhmo80ib");
    
    var raw = JSON.stringify(userLogin);
    var request = {
      "request":btoa(raw)
    }
    var final_request = JSON.stringify(request);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: final_request,
      redirect: "follow",
    };

    fetch(
      "https://erpapi.eshiksa.net/Gadvasu/Login.php",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        var resultObj = JSON.parse(result);
        console.log(resultObj);
        // eslint-disable-next-line
        if (resultObj.success == 1 && resultObj.isPaid == 0) {
         
          localStorage.setItem("studentId", resultObj.data.admission_no);
          localStorage.setItem("userId", resultObj.data.admission_no);
          localStorage.setItem("token", resultObj.data.token);
          localStorage.setItem("email", resultObj.data.email);
          setLoginObj (resultObj.form_data);
          setLoginloader(false);
          navigate('/FormStart');
          toast({
            title: "Alert",
            description: "Login successfully",
            status: "success",
            duration: 1000,
            isClosable: true,
            position: "top",
          });
        }
        // eslint-disable-next-line
        else if (resultObj.success == 1 && resultObj.isPaid == 1) {
          localStorage.setItem("userId", resultObj.admission_no);
          setPreviewlink(resultObj.url);
          setLoginloader(false);
          navigate('/FeesSubmitted');
        }
        else{
          alert(resultObj.msg);
          
          setLoginloader(false);
        }
      })
      .catch((error) => console.log("error", error));
      
    console.log(userLogin);
  };

 

  return (
    <div>
      <form onSubmit={(e) => handleLoginSubmit(e)}>
        <div className="d-flex flex-wrap w-75 mx-auto flex-column mt-5">
          <label className="form-label"> User Email </label>
          <input
            className="form-control"
            name="email"
            onChange={(e) =>
              setUserLogin({ ...userLogin, [e.target.name]: e.target.value })
            }
            type="text"
            required
          />
        </div>
        <div className="d-flex flex-wrap w-75 mx-auto flex-column my-1">
          <label className="form-label"> Password </label>
          <input
            className="form-control"
            name="password"
            onChange={(e) =>
              setUserLogin({ ...userLogin, [e.target.name]: e.target.value })
            }
            type="password"
            required
          />
        </div>
        <div className="d-flex flex-wrap w-75 mx-auto my-4 justify-content-around">
            <button
              type="submit"
              className="btn btn-sm btn-primary w-50"
              disabled={loginloader}
            >
              Submit
              {
                loginloader && <Loader/>
              }
              
            </button>       
          </div>
      </form>
    </div>
  );
}

export default Login;
